<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import { groupBy, cloneDeep } from "lodash";
import { required } from "vuelidate/lib/validators";
import createNumberMask from "text-mask-addons/dist/createNumberMask";
import MaskedInput from "vue-text-mask";
import Swal from "sweetalert2";
import RawData from "@/components/widgets/raw-data.vue";
import SubmissionDeadline from "@/components/modals/submission-deadline.vue";
export default {
    page: {
        title: "Cascaded Targets",
    },
    components: {
        Layout,
        PageHeader,
        MaskedInput,
        RawData,
        SubmissionDeadline
    },
    data() {
        return {
            title: "Target",
            submitted: false,
            items: [
                {
                    text: "Dashboards",
                    href: "/",
                },
                {
                    text: "Cascaded Targets",
                    active: true,
                },
            ],
            dus: [],
            duLoading: false,
            tableData: [],
            filter: "",
            modalTitle: "Update Target",
            pp: {
                remarks: "",
                q1: "",
                q2: "",
                q3: "",
                q4: "",
            },
            currencyMask: createNumberMask({
                prefix: "",
                allowDecimal: true,
                includeThousandsSeparator: false,
            }),
            clusterFilter: 0,
            clusters: [],
            showedCampus: null,
        };
    },
    validations: {
        pp: {
            remarks: {
                required,
            },
            q1: {
                required,
            },
            q2: {
                required,
            },
            q3: {
                required,
            },
            q4: {
                required,
            },
        },
    },
    computed: {
        filteredDUs() {
            return this.dus.filter((du) => {
                return du.name.toLowerCase().includes(this.filter.toLowerCase());
            });
        },
    },
    async created() {
        this.changeCampus(this.$store.state.data.selectedCampus.id);
        this.getClusters();
    },
    methods: {
        async getClusters() {
            await this.$store.dispatch("cluster/GetCluster")
                .then((res) => {
                    if(res.data.error){
                        return this.showSwal(res.data.errorMessage, "error");
                    }
                    this.clusters = res.data;
                })
                .catch((error) => {
                    this.showSwal('Something went wrong', "error");
                });
        },
        async changeCycle(cycle) {
            this.dus.map(item => {
                item.targets = [];
                item.showTargets = false;
            })
        },
        async changeCampus(campusId) {
            this.duLoading = true;
            this.dus = [];
            await this.getDUs(campusId);
            this.duLoading = false;
        },
        async getDUs(campusId) {
            await this.$store.dispatch("deliveryunit/GetDeliveryUnitByCampus", campusId)
                .then((res) => {
                    if(res.data.error){
                        return this.showSwal(res.data.errorMessage, "error");
                    }
                    res.data.map(item => {
                        item.targets = [];
                        item.filterTarget = '';
                        item.showTargets = false;
                        item.targetLoading = false
                    })
                    this.dus = res.data;
                })
                .catch((error) => {
                    this.showSwal('Something went wrong', "error");
                });
        },
        async openTargets(du) {
            du.showTargets = !du.showTargets;
            if(du.showTargets && du.targets.length == 0){
                du.targetLoading = true;
                await this.getTargets(du);
                du.targetLoading = false;
            }
        },
        async getTargets(du){
            await this.$store.dispatch("target/GetTargetByDU", {id: du.id, cycle: this.$store.state.data.cycle})
                .then((res) => {
                    if(res.data.error){
                        return this.showSwal(res.data.errorMessage, "error");
                    }
                    res.data.map(item => {
                        item.classification = item.mainTarget.indicatorItem.indicatorItemClassification.classification;
                        item.sort = 3;
                        if(item.mainTarget.indicatorItem.indicatorItemClassification.classification.toLowerCase().includes('strategic')){
                            item.sort = 1;
                        }else if(item.mainTarget.indicatorItem.indicatorItemClassification.classification.toLowerCase().includes('core')){
                            item.sort = 2
                        }
                    })
                    du.targets = res.data.sort((a, b) => a.sort - b.sort);
                })
                .catch((error) => {
                    this.showSwal('Something went wrong', "error");
                });
        },
        filteredByClass(targets, filtr){
            let data = [];
            if(filtr){
                data = targets.filter((target) => {
                    return target.remarks.toLowerCase().includes(filtr.toLowerCase());
                });
            }else{
                data = targets;
            }
            var groupedClass = groupBy(data, "classification");
            var classID = 1;
            var grouped = [];
            for (const key in groupedClass) {
                grouped.push({
                    id: classID++,
                    data: groupedClass[key],
                    key: key,
                });
            }
            return grouped;
        },
        postTarget(target, parent){
            Swal.fire({
                title: "Are you sure?",
                text: "You are about to post this target.",
                icon: "question",
                showCancelButton: true,
                confirmButtonColor: "#34c38f",
                cancelButtonColor: "#5c636a",
                confirmButtonText: "Yes, post it!",
            }).then((result) => {
                if (result.value) {
                    this.$store
                        .dispatch("target/PostTarget", target.id)
                        .then((res) => {
                            if(res.data.error){
                                return this.showSwal(res.data.errorMessage, "error");
                            }
                            let index = parent.targets.findIndex((x) => x.id == target.id);
                            // parent.targets.splice(index, 1);
                            parent.targets[index].status = "POSTED"
                            this.showToast("Posted Successfully!", "success");
                        })
                        .catch((err) => {
                            this.showToast("Error posting!", "error");
                        });
                }
            });
        },
        unpostTarget(target, parent){
            Swal.fire({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#dc3545",
                cancelButtonColor: "#5c636a",
                confirmButtonText: "Yes, unpost it!",
            }).then((result) => {
                if (result.value) {
                    this.$store
                        .dispatch("target/UnPostTarget", target.id)
                        .then((res) => {
                            if(res.data.error){
                                return this.showSwal(res.data.errorMessage, "error");
                            }
                            let index = parent.targets.findIndex((x) => x.id == target.id);
                            // parent.targets.splice(index, 1);
                            parent.targets[index].status = "PENDING"
                            this.showToast("Unposted Successfully!", "success");
                        })
                        .catch((err) => {
                            this.showToast("Error unposting!", "error");
                        });
                }
            });
        },
        updateTarget(target, parent){
            this.selectedDU = parent;
            this.pp = cloneDeep(target);
            this.pp.q1 = this.pp.q1 ? this.pp.q1.toString() : "0";
            this.pp.q2 = this.pp.q2 ? this.pp.q2.toString() : "0";
            this.pp.q3 = this.pp.q3 ? this.pp.q3.toString() : "0";
            this.pp.q4 = this.pp.q4 ? this.pp.q4.toString() : "0";
            this.pp.cascadedTarget = this.pp.cascadedTarget ? this.pp.cascadedTarget.toString() : "0";
            this.$bvModal.show("update-target-modal");
        },
        onUpdateTarget(){
            this.submitted = true;
            this.$v.pp.$touch();
            if (this.$v.pp.$invalid) {
                return;
            }
            let data = cloneDeep(this.pp);
            data.q1 = this.getExactAmt(this.pp.q1)
            data.q2 = this.getExactAmt(this.pp.q2)
            data.q3 = this.getExactAmt(this.pp.q3)
            data.q4 = this.getExactAmt(this.pp.q4)
            this.$store
                .dispatch("target/UpdateTarget", data)
                .then((res) => {
                    if(res.data.error){
                        return this.showSwal(res.data.errorMessage, "error");
                    }
                    let index = this.selectedDU.targets.findIndex((x) => x.id == this.pp.id);
                    this.selectedDU.targets.splice(index, 1, this.pp);
                    this.showToast("Target Updated Successfully!", "success");
                    this.$bvModal.hide("update-target-modal");
                })
                .catch((err) => {
                    this.showToast("Error updating target!", "error");
                });
        },
        setDeadline(duId, duName) {
            let deadlineArray = [
                {
                    label: "Deadline of Submission",
                    type: "PLANNING",
                    referenceType: duId ? "Accomplishment - DU" : "Accomplishment",
                    referenceId: duId ? duId : 0,
                },
                {
                    label: "Deadline for Returned Targets",
                    type: "PLANNING",
                    referenceType: duId ? "Returned - DU" : "Returned",
                    referenceId: duId ? duId : 0,
                },
            ]
            let title = duName ? `Set Deadline for ${duName}` : "Set Deadline";
            this.$refs.SubmissionDeadline.setData(deadlineArray, title);
        },
        calculateAnnualTarget() {
            if (!this.pp.mainTarget.isPercentage) {
                let total =
                parseFloat(this.pp.q1 ? this.pp.q1 : 0) +
                parseFloat(this.pp.q2 ? this.pp.q2 : 0) +
                parseFloat(this.pp.q3 ? this.pp.q3 : 0) +
                parseFloat(this.pp.q4 ? this.pp.q4 : 0);
                this.pp.cascadedTarget = total.toString();
            } else {
                let lastQuarter = 0;
                if (parseFloat(this.pp.q1 ? this.pp.q1 : 0) != 0)
                lastQuarter = parseFloat(this.pp.q1);
                if (parseFloat(this.pp.q2 ? this.pp.q2 : 0) != 0)
                lastQuarter = parseFloat(this.pp.q2);
                if (parseFloat(this.pp.q3 ? this.pp.q3 : 0) != 0)
                lastQuarter = parseFloat(this.pp.q3);
                if (parseFloat(this.pp.q4 ? this.pp.q4 : 0) != 0)
                lastQuarter = parseFloat(this.pp.q4);
                this.pp.cascadedTarget = lastQuarter.toString();
            }
        },
        async getDusByCluster(clusterId){
            await this.$store.dispatch("deliveryunit/getDeliveryUnitByCluster", clusterId)
                .then((res) => {
                    if(res.data.error){
                        return this.showSwal(res.data.errorMessage, "error");
                    }
                    res.data.map(item => {
                        item.targets = [];
                        item.filterTarget = '';
                        item.showTargets = false;
                        item.targetLoading = false
                    })
                    this.dus = res.data.sort((a, b) => a.campus.localeCompare(b.campus));   
                })
                .catch((error) => {
                    this.showSwal('Something went wrong', "error");
                });
        },
        async applyFilter(){
            if(this.clusterFilter != 0){
                this.showedCampus = null;
                this.duLoading = true;
                this.dus = [];
                await this.getDusByCluster(this.clusterFilter);
                this.duLoading = false;
            }else{
                this.changeCampus(this.$store.state.data.selectedCampus.id);
            }
        },
    },
};
</script>

<template>
    <Layout @changeCycle="changeCycle" @changeCampus="changeCampus($event.id)">
        <PageHeader :title="title" :items="items" />
        <b-modal
            id="update-target-modal"
            :title="modalTitle"
            size="md"
            title-class="font-18"
            hide-footer
            no-close-on-backdrop
            no-close-on-esc
            >
            <form
                @submit.prevent="onUpdateTarget"
                class="needs-validation"
                ref="targetForm"
            >
                <div>
                <label for="">Target Description</label>
                <textarea
                    class="form-control"
                    placeholder="Type Target Description Here..."
                    rows="5"
                    v-model="pp.remarks"
                    :class="{
                    'is-invalid': submitted && $v.pp.remarks.$error,
                    }"
                ></textarea>
                </div>
                <div class="my-3">
                    <label for="">Quarterly Target</label>
                    <div class="row">
                        <div class="col-md-3" v-for="x in 4" :key="x">
                            <div class="d-flex align-items-center">
                                <masked-input
                                    type="text"
                                    class="form-control w-100 text-center"
                                    :placeholder="`Quarter ${x}`"
                                    v-model="pp[`q${x}`]"
                                    :mask="currencyMask"
                                    :class="{
                                        'is-invalid': submitted && $v.pp[`q${x}`].$error,
                                    }"
                                    @input="calculateAnnualTarget()"
                                ></masked-input>
                            </div>
                            <div class="text-center">
                                <small>Quarter {{ x }}</small>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="mb-3">
                    <label for="">Annual Target</label>
                    <masked-input
                        type="text"
                        class="form-control"
                        v-model="pp.cascadedTarget"
                        :mask="currencyMask"
                    />
                </div>
                <div class="modal-footer">
                <button type="submit" class="btn btn-primary">Save changes</button>
                <button
                    type="button"
                    class="btn btn-link"
                    @click="$bvModal.hide('update-target-modal')"
                >
                    Close
                </button>
                </div>
            </form>
            </b-modal>
        <div class="d-flex align-items-center justify-content-between">
            <div class="d-flex align-items-center gap-2">
                <h4 class="mb-0">List of Targets by Delivery Unit</h4>
                <button id="filter-target" class="btn btn-primary"><i class="bx bx-filter"></i> Filters</button>
                <b-popover
                    target="filter-target"
                    triggers="click blur"
                    placement="right"
                  >
                    <template v-slot:title>
                      <div
                        class="d-flex align-items-center justify-content-between"
                      >
                        <small>Filter by Cluster:</small>
                      </div>
                    </template>
                    <div class="d-flex flex-column gap-2 mb-3">
                      <select class="form-select" v-model="clusterFilter">
                        <option value="0">All Clusters</option>
                        <option :value="x.id" v-for="x in clusters" :key="x.id">{{x.clusterName}}</option>
                      </select>
                    </div>
                    <button class="btn btn-primary btn-block btn-sm" @click="applyFilter">Apply</button>
                </b-popover>
            </div>
            <div id="tickets-table_filter" class="dataTables_filter">
                <button
                    v-if="$store.state.decrypt.isAdmin()"
                    @click="setDeadline()"
                    type="button"
                    class="btn btn-purple me-2"
                    >
                    <i class="bx bx-calendar me-1"></i>
                    Set Deadline (Globally by Campus)
                </button>
                <label class="d-inline-flex align-items-center mb-0">
                    <b-form-input
                        autocomplete="off"
                        v-model="filter"
                        type="search"
                        placeholder="Search Delivery Unit..."
                        class="form-control"
                    ></b-form-input>
                </label>
            </div>
        </div>
        <div class="my-3">
            <div v-if="duLoading">
                <h3>Loading...</h3>
            </div>
            <div v-if="dus.length == 0 && !duLoading">
                <h3>No data found...</h3>
            </div>
            <div v-if="dus.length > 0 && filteredDUs.length == 0">
                <h3>Search not found</h3>
            </div>
            <div v-if="dus.length && !duLoading">
                <ul>
                    <li
                        v-for="x in filteredDUs"
                        :key="x.id"
                        class="w-100 mb-2"
                    >
                        <div
                            class="d-flex align-items-center justify-content-between"
                        >
                            <div class="d-flex align-items-center">
                                <a
                                    href="javascript:void(0);"
                                    class="font-size-18 text-dark"
                                    @click="openTargets(x)"
                                >
                                    <span
                                    :class="{
                                        'text-yellow': x.showTargets,
                                        'text-white': !x.showTargets,
                                    }"
                                    >
                                    <template v-if="x.campus">{{x.campus}} - </template>{{ x.name }}
                                    </span>
                                    <i
                                    class="bx bx-caret-right rotate"
                                    :class="{
                                        'rotate-90 text-yellow': x.showTargets,
                                        'text-white': !x.showTargets,
                                    }"
                                    ></i>
                                </a>
                            </div>
                            <div v-if="x.showTargets">
                                <div class="dataTables_filter">
                                    <button
                                        v-if="$store.state.decrypt.isAdmin()"
                                        @click="setDeadline(x.id, x.name)"
                                        type="button"
                                        class="btn btn-sm btn-purple me-2"
                                        >
                                        <i class="bx bx-calendar me-1"></i>
                                        Set Deadline
                                    </button>
                                    <label class="d-inline-flex align-items-center mb-0">
                                        <b-form-input
                                            autocomplete="off"
                                            v-model="x.filterTarget"
                                            type="search"
                                            placeholder="Search Target..."
                                            class="form-control form-control-sm"
                                        ></b-form-input>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <b-collapse
                            :visible="x.showTargets"
                            :accordion="`du-accordion-${x.id}`"
                            role="tabpanel"
                        >
                            <div class="pt-2" v-if="x.showTargets">
                                <div
                                    class="p-3 d-flex align-items-center"
                                    v-if="x.targetLoading"
                                >
                                    <div class="preloader-component me-2">
                                    <div class="status">
                                        <div class="spinner-chase w-20px h-20px">
                                        <div class="chase-dot"></div>
                                        <div class="chase-dot"></div>
                                        <div class="chase-dot"></div>
                                        <div class="chase-dot"></div>
                                        <div class="chase-dot"></div>
                                        <div class="chase-dot"></div>
                                        </div>
                                    </div>
                                    </div>
                                    <h5 class="mb-0">Loading...</h5>
                                </div>
                                <div v-else class="position-relative">
                                    <template v-if="x.targets.length">
                                        <b-tabs
                                            pills
                                            vertical
                                            nav-class="p-0"
                                            nav-wrapper-class="col-sm-2"
                                            content-class="pt-0 px-2 text-muted"
                                        >
                                            <b-tab v-for="z in filteredByClass(x.targets, x.filterTarget)" :key="z.id">
                                                <template v-slot:title>
                                                    {{z.key}}
                                                </template>
                                                <div>
                                                    <div
                                                        class="card mb-1 shadow-none"
                                                        v-for="(y, yIndex) in z.data"
                                                        :key="`target-${y.id}`"
                                                    >
                                                        <RawData
                                                            :data="y"
                                                            v-if="$store.state.decrypt.isAdmin()"
                                                            :keyId="`DU${x.id}-Type${z.id}-Target${y.id}`"
                                                        />
                                                        <b-card-header class="border">
                                                            <div
                                                                class="d-flex justify-content-between"
                                                                :class="{ 'mb-3': y.showDetails }"
                                                            >
                                                                <div class="d-flex align-items-center">
                                                                    <div class="bg-success bg-gradient text-center me-2 py-1 position-relative" style="min-width: 30px">
                                                                        <h3 class="mb-0 position-relative">{{ yIndex + 1 }}</h3>
                                                                    </div>
                                                                    <div>
                                                                        <h5 class="mb-0">
                                                                            {{ y.remarks }}
                                                                        </h5>
                                                                        <div>
                                                                            <small><a href="javascript:void(0)" class="text-green" @click="updateTarget(y, x)">Update Target</a></small>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div v-if="$store.state.decrypt.isAdmin()" style="min-width: max-content;">
                                                                <button v-if="y.status.toUpperCase() !== 'PENDING'" type="button" class="btn btn-sm btn-warning" @click="unpostTarget(y, x)">Unpost</button>
                                                                <button v-else type="button" class="btn btn-sm btn-success" @click="postTarget(y, x)">Post</button>
                                                                </div>
                                                            </div>
                                                        </b-card-header>
                                                    </div>
                                                </div>
                                            </b-tab>
                                        </b-tabs>
                                    </template>
                                    <template v-else>
                                        <h3>No data found...</h3>
                                    </template>
                                </div>
                            </div>
                        </b-collapse>
                    </li>
                </ul>
            </div>
        </div>
    <SubmissionDeadline ref="SubmissionDeadline"></SubmissionDeadline>
    </Layout>
</template>